/**
 * Compara una lista nueva (traída del backend en cada poll) contra la lista
 * anterior en memoria y reutiliza la MISMA referencia de objeto para las
 * filas que no cambiaron. Esto permite que React.memo() en los componentes
 * de fila evite re-renders innecesarios y que el mapa Leaflet no recree
 * markers que no cambiaron de posición/estado.
 *
 * @returns {{ merged: Array, changed: boolean }} `changed=false` indica que
 *   se puede descartar por completo el nuevo array y mantener el anterior
 *   (evita un setState/render de más).
 */
export function mergeStable(prevList, nextList, keyFn = (item) => item.id) {
  // `prevList === null` significa "todavía no cargó nada" (estado inicial/skeleton),
  // distinto de una lista vacía ya cargada — siempre se considera "changed" para
  // que el skeleton se apague con el primer resultado, aunque venga vacío.
  if (prevList === null) return { merged: nextList, changed: true };

  const prevArr = prevList || [];
  const prevMap = new Map(prevArr.map((item) => [keyFn(item), item]));
  let changed = prevArr.length !== nextList.length;

  const merged = nextList.map((item) => {
    const prev = prevMap.get(keyFn(item));
    if (prev && shallowEqual(prev, item)) return prev;
    changed = true;
    return item;
  });

  return { merged, changed };
}

function shallowEqual(a, b) {
  const ka = Object.keys(a);
  const kb = Object.keys(b);
  if (ka.length !== kb.length) return false;
  for (const k of ka) {
    if (a[k] !== b[k]) return false;
  }
  return true;
}
